import { createContext } from 'react'

export const UserCompiledQuestContext = createContext({
  ids: { studentId: null, courseSectionId: null, levelId: null },
  userCompiledQuest: null,
  compiledQuest: null,
  courseOverview: null,
  courseSection: null,
  isActivityCourseQuest: false,
  isEnrolled: false,
  courseSectionStudents: [],
  userQuestActivityNotes: [],
  userQuestActivityAttachments: [],
  userQuestActivityArtifacts: [],
  userCompiledQuestSkillChecks: [],
  userCompiledQuestPendingMentorFeedback: null,
  userQuestLogEvents: [],
  compiledQuestSkills: [],
  compiledQuestPeers: [],
  userCompiledQuestArtifactAssessments: [],
  mentorActivityCheckpointOverrides: [],
  targetDates: [],
  selectedActivityId: null,
  userQuestActivity: null,
  sidePanelCollapsedState: [],
  navigationNotification: null,
  navigationScrollTo: null,
  navigationOpenEditor: null,
  onFetchUserQuestActivity: () => {},
  onBeginQuest: () => {},
  onDropQuest: () => {},
  onQuestCompleteSuccess: () => {},
  onActivityNoteUpdated: () => {},
  onQuestLogEventMessageAdded: () => {},
  onQuestLogEventMessageReadToggled: () => {},
  onAssessmentReadToggled: () => {},
  onNoteReadToggled: () => {},
  onSkillsCheckReadToggled: () => {},
  onWorkItemReadToggled: () => {},
  onSkillsCheckMutation: () => {},
  onUserWorkItemMutation: () => {},
  onFocusSkillMutation: () => {},
  onArtifactAssessmentUpdated: () => {},
  onMentorFeedbackProvided: () => {},
  onNavigationComplete: () => {},
  onActivityCheckpointOverridesUpdated: () => {}
})

export const UserActivitySkillCheckContext = createContext({
  skills: [],
  courseSectionId: null,
  levelId: null,
  userCompiledQuestId: null,
  userQuestActivityId: null,
  activityId: null
})
